import { ServiceWithSession } from './base-service';
import type { FormSession } from './form-session';

export default class PaymentService extends ServiceWithSession {
	constructor(session: FormSession) {
		super(session);
	}

	async createOrder(orderAmount: number, currencyCode: string, formId: string, clientToken: string) {
		return this.serviceRequest({
			method: 'POST',
			endpoint: 'svc/paypal-form/create-order',
			data: {
				OrderAmount: orderAmount,
				CurrencyCode: currencyCode,
				FormId: formId,
				ClientToken: clientToken
			},
			headers: this.getValidationHeaders()
		});
	}

	async getIdentifier(token: string, paymentMethod: string, clientToken: string) {
		return this.serviceRequest({
			method: 'GET',
			endpoint: `svc/paypal-form/identifier?payPalToken=${token}&paymentMethod=${paymentMethod}&clientToken=${clientToken}`,
			headers: this.getValidationHeaders()
		});
	}

	async getPayPalConfig(): Promise<PayPalClientConfig> {
		const result = await this.serviceRequest({
			method: 'GET',
			endpoint: 'svc/paypal-form/client-config',
			params: { formId: this.session.formId },
			headers: this.getValidationHeaders()
		});

		return result.response.data as PayPalClientConfig;
	}
}

export type PayPalClientConfig = {
	ClientToken: string;
	MerchantId: string;
	TrackingId: string;
};